import { collection, getCountFromServer, query, where } from "firebase/firestore";
import Failure from "../../../core/Failure";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import SubscriptionDataSource from "../../enums/subscription/subscription_datasource/SubscriptionDataSource";

async function getCRMStats(): Promise<Record<SubscriptionDataSource, number>> {
  try {
    const db = firestore;
    const subscriptionsCollection = collection(db, FirestoreCollections.subscriptions);
    const crmStats: Record<SubscriptionDataSource, number> = {} as Record<SubscriptionDataSource, number>;

    for (const crm of Object.values(SubscriptionDataSource)) {
      const subscriptionSnaphsot = await getCountFromServer(query(subscriptionsCollection, where('datasource', '==', crm)));
      if (subscriptionSnaphsot.data().count) {
        crmStats[crm] = subscriptionSnaphsot.data().count;
      }
    }

    return Object.fromEntries(
      Object.entries(crmStats)
        .sort(([, crmCountA], [, crmCountB]) => crmCountB - crmCountA)
    ) as Record<SubscriptionDataSource, number>;
  } catch (e) {
    console.log("error: ", e);
    throw new GetCRMStatsStatsFailure();
  }
}

export class GetCRMStatsStatsFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default getCRMStats;
